import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Router, NavigationExtras } from "@angular/router";
import { BaseProvider } from "../BaseProvider";
import {
    BranchRequestModel,
    BranchResponseModel,
    LoginResponseModel,
} from "../../_models/index";
import { GlobalService } from "../../_global/global.service";

@Injectable()
export class BranchsService extends BaseProvider {
    resource = "branches";

    constructor(
        private http: Http,
        private router: Router,
        private _gs: GlobalService,
    ) {
        super(http);
    }
    getBranch() {
        // Fetch all branches given the token
        return this.makeGetCall(
            this.resource + "?partnerId=" + this._gs.currentUser.partner.id,
        );
    }

    getNearByBranch(latitude = 0.0, longitude = 0.0) {
        var resourceUrl =
            "nearestBranchToCustomer?latitude=" +
            latitude +
            "&longitude=" +
            longitude;
        return this.makeGetCall(resourceUrl);
    }

    getBranchByPartner(partnerId: any) {
        // Fetch all branches given the token
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }
        return this.makeGetCall(this.resource + "?partnerId=" + partnerId);
    }
    getBranchId(branchId) {
        // Fetch a particular branch details given the id
        return this.makeGetCall(this.resource + "/" + branchId);
    }
    addBranch(BranchRequest: BranchRequestModel) {
        // Add a branch  given the branch details
        return this.makePostCall(this.resource, BranchRequest);
    }
    editBranch(branch) {
        // edit Branch Redirect By ID
        const navigationExtras: NavigationExtras = {
            queryParams: {
                id: branch.id,
            },
        };
        this.router.navigate(["/admin/branch/edit"], navigationExtras);
    }

    updateBranch(branch, branchId) {
        // Update an branch  given the updated branch details
        return this.makePatchCall(this.resource + "/" + branchId, branch);
    }

    // updateBranch(branch, branchId) { // Update an branch  given the updated branch details
    //     return this.makePutCall(this.resource + '/' + branchId, branch);
    // }
    deleteBranch(branchId) {
        // Delete an branch  given the branch id
        return this.makeDeleteCall(this.resource + "/" + branchId);
    }
    updateBranchStatus(branchId, requestModel: any) {
        // Update an branch  given the updated branch details
        return this.makePatchCall(this.resource + "/" + branchId, requestModel);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/branch/branchs.service.ts